


























import Vue from 'vue';
import Component from 'vue-class-component';
import VueApexCharts from 'vue-apexcharts';
import { Prop } from 'vue-property-decorator';

@Component({
    components: {
        apexchart: VueApexCharts,
    },
    name: 'card-radial-bar-chart',
})
export default class CardRadialBarChart extends Vue {
    @Prop({ required: true })
    title!: string;

    @Prop({ required: true })
    cardColor!: string;

    @Prop({ required: true })
    chartColor!: string;

    @Prop({ required: true })
    fontColor!: string;

    get chartType(): string {
        return 'radialBar';
    }

    get chartSeries(): number[] {
        return [100];
    }

    get chartOptions(): object {
        const fontFamily = 'Roboto, sans-serif';

        return {
            chart: {
                type: this.chartType,
                width: '100%',
                height: '100%',
                offsetY: -8,
                fontFamily,
                sparkline: {
                    enabled: true,
                },
            },
            colors: [this.chartColor],
            plotOptions: {
                radialBar: {
                    hollow: {
                        margin: 0,
                        size: '60%',
                    },
                    track: {
                        background: '#e7e7e7',
                        strokeWidth: '97%',
                        dropShadow: {
                            enabled: true,
                            top: 2,
                            left: 0,
                            color: '#999',
                            opacity: 1,
                            blur: 2,
                        },
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'light',
                            shadeIntensity: 0.4,
                            inverseColors: false,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 50, 53, 91],
                        },
                    },
                    dataLabels: {
                        showOn: 'always',
                        name: {
                            show: false,
                        },
                        value: {
                            show: true,
                            offsetY: 15,
                            color: this.fontColor,
                            fontSize: '1.75rem',
                            fontWeight: 400,
                        },
                    },
                },
            },
        };
    }
}
